export default __webpack_public_path__ + "static/basePersonajeMenstruacion-f8bcf809f5727688d67515cb26d59be0.png";